<script lang="ts">
    export let associate;
</script>
{#if associate}
<div class="overflow-hidden">
    <h3 class="truncate">{associate.name}</h3>
    <div class="text-sm text-neutral-500 truncate">
        {associate.email}
    </div>
</div>
{/if}